<template>
    <div class="enjoyedService">
        <div class="card">
            <van-swipe
                class="my-swipe"
                indicator-color="white"
                :width="234"
                :loop="false"
                @change="onChange"
            >
                <van-swipe-item v-for="item in cardList" :key="item.id">
                    <div class="item" :class="{ man: item.sex === '0' }">
                        <div class="left">
                            <img v-if="item.sex === '1'" src="@/assets/images/youngwoman.png" alt />
                            <img v-else src="@/assets/images/youngman.png" alt />
                        </div>
                        <div class="middle">
                            <p>{{ item.myRelationName || "本人" }}</p>
                            <p>{{ item.fullName }}</p>
                        </div>
                        <div class="right">{{ item.idCard | GetAge }}岁</div>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>

        <div class="list">
            <div class="list_item" v-for="item in serviceList" :key="item.id">
                <div class="title">{{ item.serviceName }}</div>
                <div class="footer">开始时间: {{ item.permitDate | getDate("YYYY-MM-DD HH:mm") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getApplyRecored } from "@/api/service.js";
import { getFamilyInfoList, getUserInfoDetail } from "@/api/user.js";
export default {
    name: "enjoyedService",
    data() {
        return {
            form: {
                openId: this.$store.state.user.openId,
                applyStatus: "2",
                proxyWxUserId: ""
            },
            cardList: [],
            serviceList: []
        };
    },
    methods: {
        onChange(index) {
            this.form.proxyWxUserId = this.cardList[index].id;
            this.getData();
        },
        async getData() {
            const { data } = await getApplyRecored(this.form);
            this.serviceList = data.list;
        },
        async getFamilyData() {
            const { data } = await getFamilyInfoList(this.form);
            this.cardList = data;
            const { data: result } = await getUserInfoDetail(
                this.$store.state.user.openId
            );
            this.cardList.unshift(result);
        }
    },
    async mounted() {
        await this.getFamilyData();
        this.form.proxyWxUserId = this.cardList[0].id;
        this.getData();
    }
};
</script>

<style lang="scss" scoped>
.enjoyedService {
    padding-left: 20px;
    padding-top: 20px;

    .card {
        ::v-deep {
            .van-swipe__track {
                height: 120px;
                // background-color: green;
            }
        }
        .my-swipe .van-swipe-item {
            // background-color: red;
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            .item {
                &.man {
                    background-color: #e8f4fd;
                }
                box-shadow: 2px 2px 10px #ccc;
                border-radius: 10px;
                color: #654614;
                display: flex;
                width: 218px;
                height: 96px;
                background-color: #ffedbb;
                .left {
                    width: 70px;
                    height: 70px;
                    // background-color: red;
                    img {
                        width: 56px;
                    }
                }
                .middle {
                    p {
                        line-height: 50px;
                        opacity: 0.9;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-Bold;
                        font-weight: 700;
                        text-align: center;
                        color: #543302;
                    }
                }
                .right {
                    padding-left: 20px;
                    opacity: 0.9;
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: center;
                    color: #543302;
                    line-height: 50px;
                }
            }
        }
    }
    .list {
        .list_item {
            border-bottom: 4px solid #fff8e9;
            height: 99px;
            //   background-color: red;
            padding-top: 19px;
            .title {
                // background-color: greenyellow;
                height: 22px;
                opacity: 1;
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Bold;
                font-weight: 700;
                text-align: left;
                color: #543302;
                margin-bottom: 20px;
            }
            .footer {
                // background-color: blue;
                width: 174px;
                height: 17px;
                opacity: 0.75;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Bold;
                font-weight: 700;
                text-align: left;
                color: #543302;
            }
        }
    }
}
</style>
